import { cva } from '@/styled-system/css';

export const switchRootRecipe = cva({
  base: {
    'display': 'inline-block',
    'lineHeight': '0',
    'position': 'relative',
    'cursor': 'pointer',

    // FOCUSED
    '& > .c11n_switch__input:focus-visible + .c11n_switch__track': {
      boxShadow: 'focus',
    },
  },
});
